/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsHome} from '../api'

 export const useQueryGetSavingsHome = createReactQueryHook('getSavingsHome', getSavingsHome)
